import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {Col, Row} from "antd";
import './Fleetback.css'
import DateFormat from "../../common/format/DateFormat";

class FleetbackHistory extends Component {

  render() {
    const {intl:{formatMessage}, fleetbackIntervention} = this.props;


    return (
      <React.Fragment>
        <h4>{formatMessage({id: 'fleetback.history.title'})}</h4>
        {fleetbackIntervention.history && fleetbackIntervention.history.map((h, index)=>
          <Row key={index}>
            <Col span={8}><DateFormat date={h.createdOn} layout="dateTimeLong"/></Col>
            <Col span={16}>{formatMessage({id: `fleetback.intervention.history.${h.type}`})}</Col>
          </Row>)
        }
      </React.Fragment>
    );
  }
}

export default injectIntl(FleetbackHistory);
